import { Component, OnInit, Input, Output , EventEmitter} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ErrorHandler } from '@root/utils/error-handler.service';
import { InvestorListData } from '@investor-list/investor-list-container.model';
import { InvestorBlockDialogComponent } from '@investor-list/investor-block-dialog/investor-block-dialog.component';
import { InvestorListService } from '@investor-list/investor-list.service';


@Component({
  selector: 'app-investor-list-container',
  templateUrl: './investor-list-container.component.html',
  styleUrls: ['./investor-list-container.component.scss'],
})
export class InvestorListContainerComponent implements OnInit {

  @Input() investorList: InvestorListData[] = [];

  @Output() refersh = new  EventEmitter();

  panelMap: { [key: string]: boolean } = {};

  blockInvestorObj: any;

  constructor(
    private investorListService: InvestorListService,
    private errorHandler: ErrorHandler,
    private toastr: ToastrService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
  }


  public openBlockOrUnblockDialog(investor: InvestorListData, device?: any) {
    const isDevice = !!device;
    const isBlock  = isDevice ? !device.status : investor.isBlocked;
    const dialogRef = this.dialog.open(InvestorBlockDialogComponent, {
      width: '486px',
      data: { investor, device, isBlock },
    });

    dialogRef.afterClosed().subscribe((response) => {
      if(response){
        if(isDevice){
        }else{
            this.blockIFA(investor, isBlock);
        }
      }
    });
  }

  private blockIFA(investor: any, status: boolean){
    this.blockInvestorObj = {
      id: investor.id,
      status: status ? 1 : 0
    };

    this.investorListService.blockInvestor(this.blockInvestorObj).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
          this.refersh.emit();
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }
 

 
}
